export default async ({ $api, app, redirect, route, store }) => {
  const fail = () => {
    redirect(302, app.localePath('/compare-home-insurance/'));
  };
  const identifier = route.query.identifier;
  if (!identifier) {
    return fail();
  }
  await $api('protection/home_insurance_orders', { identifier, method: 'post' }).then(order => store.commit('order/set', order));
};
